import React from 'react';
import styled, { css } from 'styled-components';
import { SxProps } from '@mui/system';

type WrapperProps<T extends React.ElementType> = {
  as: T;
  show?: 'desktop' | 'mobile';
  sx?: SxProps;
} & React.ComponentProps<T>;

const mobileStyles = css<WrapperProps<any>>`
  display: ${(props) => (props.show === 'mobile' ? 'block' : 'none')};

  @media (min-width: 768px) {
    display: none;
  }
`;

const desktopStyles = css<WrapperProps<any>>`
  display: ${(props) => (props.show === 'desktop' ? 'block' : 'none')};

  @media (max-width: 767px) {
    display: none;
  }
`;

const MobileStyledWrapper = styled.div<WrapperProps<any>>`
  ${mobileStyles}
`;

const DesktopStyledWrapper = styled.div<WrapperProps<any>>`
  ${desktopStyles}
`;

export const ResponsiveElement = <T extends React.ElementType>({
  as: Component,
  children,
  show,
  ...props
}: WrapperProps<T>) => {
  return (
    <>
      {show === 'mobile' && (
        <MobileStyledWrapper as={Component} show={show} {...props}>
          {children}
        </MobileStyledWrapper>
      )}
      {show === 'desktop' && (
        <DesktopStyledWrapper as={Component} show={show} {...props}>
          {children}
        </DesktopStyledWrapper>
      )}
    </>
  );
};
